import { z } from "zod";

import { zOut as zBaseOut } from "./common";

const zOut = z.array(zBaseOut);
type Out = z.infer<typeof zOut>;

export { zOut };
export type { Out };
